import React from 'react'
import { useTranslation } from '@/shared/contexts/TranslationContext'

export function PoultryDashboard() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
      <svg className="w-16 h-16 text-amber-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
      <h1 className="text-2xl font-bold text-slate-800 dark:text-white mb-2">{t('poultry.dashboard_title') || 'Granja'}</h1>
      <p className="text-slate-500 dark:text-slate-400">{t('common.page_under_construction') || 'Dashboard em construção'}</p>
    </div>
  )
}
